export const contactsData = {
    email: 'migrantraptor@gmail.com',
    phone: '9084871339',
    instagram: 'https://www.instagram.com/photosbymanish/',
    linkedIn: 'https://www.linkedin.com/in/msharma06/',
    medium: 'https://medium.com/@animanis',
}